const requestsPerPage = 20;

export {
  requestsPerPage,
};

export default requestsPerPage;
